import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'filetype',
})
export class FiletypePipe implements PipeTransform {

    transform(type: string, ...args: unknown[]): string {

        if (type.startsWith('audio/')) {
            return 'Audio';
        }

        switch (type) {
            case 'application/pdf':
                return 'PDF';
            case 'audio/webm':
                return 'Audio';
            case 'text/plain':
                return 'Text';
            case 'image/jpeg':
                return 'Bild';
            case 'image/png':
                return 'Bild';
            case 'video/mp4':
                return 'Video';
            case 'video/webm':
                return 'Video';
            case 'application/msexcel':
                return 'Excel';
            case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                return 'Excel';
            case 'application/msword':
                return 'Word';
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                return 'Word';
            case 'application/mspowerpoint':
                return 'PowerPoint';
            case 'application/vnd.openxmlformats-officedocument. presentationml.presentation':
                return 'PowerPoint';
            default:
                return type;
        }
    }

}
